import React, { useEffect } from "react";

import HeaderMenu from "../../component/Navbar/headermenu";
import CustomFooter from "../../component/Footer/customFooter";
import { useData } from "../../OnBoard/DaysContext";
const TermsAndConditions = () => {
  useEffect(() => {
    document.title = "Terms & Conditions - Simplifyte";
  }, []);

  const { days, loading } = useData();
  return (
    <>
      <HeaderMenu />
      <div className="p-4 md:p-8 max-w-4xl mx-auto text-gray-800">
        <h1
          className="font-size-same text-2xl font-bold mb-6"
          style={{ marginTop: "108px" }}
        >
          Terms of Service
        </h1>

        <p className="mb-4" style={{ textAlign: "justify" }}>
          {/* These Terms of Service (“Terms”) constitute an agreement between you
          (“Customer”, “you”, or “your”) and Simplifyte Labs Private Limited
          (“Simplifyte”, “we”, “us”, or “our”), governing your use of the
          Simplifyte digital work flow platform and related services (the
          “Service”). By accessing or using the Service, you agree to be bound
          by these Terms. You represent that you have the legal capacity to
          enter this agreement (the Service is available to all users, including
          students and teams, but under-18 users should have parental consent).
          Our corporate details: Simplifyte Labs Private Limited, 5th Floor,
          Meghani Luxe, Meghani Circle, Bhavnagar-364001, Gujarat, India. */}
          These Terms of Service (“Terms”) constitute an agreement between you
          (“Customer”, “you” or “your”) and Simplifyte Labs Private Limited
          (“Simplifyte”, “we”, “us” or “our”), governing your use of the
          Simplifyte digital work flow platform and related services (the
          “Service”). By accessing or using the Service, you agree to be
          following these Terms. Accordingly, you have the legal capacity to
          enter this agreement (the Service is available to all users, including
          students and teams, but under-18 users should have parental consent).
          Our corporate details: Simplifyte Labs Private Limited, 4th Floor,
          Meghani Luxe, Meghani Circle, Bhavnagar-364001, Gujarat, India.
        </p>

        <ul
          className="policy-list list-disc list-inside space-y-2 mb-4"
          style={{ textAlign: "justify" }}
        >
          <li>
            <strong>Service Use:</strong> We grant you a limited, non-exclusive,
            non-transferable license to access and use the Service solely for
            your internal business or personal purposes. You may not sublicense,
            resell, or distribute the Service. You agree to use the Service in
            compliance with applicable laws (India’s IT Act 2000, DPDP Act 2023,
            Consumer Protection Act, GDPR, etc.) and these Terms.
          </li>
          <li>
            <strong>Account:</strong> {""}
            {/* You must register for an account to use
            the Service. You agree to provide accurate information and keep your
            login credentials confidential. You are responsible for all activity
            under your account. If your account is compromised, notify us
            immediately. */}
            You must register for an account to use the Service. You agree to
            provide accurate information and keep your login credentials
            confidential. Also, you are responsible for all activity under your
            account. If your account is compromised, notify us immediately.
          </li>
          <li>
            <strong>Subscription and Billing:</strong> {""}
            {/* Simplifyte offers free
            and paid subscription plans. New users receive a 7-day free trial at
            signup. During the trial, the Service is free; if not canceled
            before trial end, your chosen paid plan will commence and you will
            be charged the applicable fee. You may cancel anytime before the
            trial expires to avoid charges. After the trial, subscriptions renew
            automatically on the due date (e.g. monthly or annually, as chosen).
            You authorize us (via Razorpay or other payment gateway) to charge
            your chosen payment method (credit/debit card, UPI, etc.) for the
            subscription fees, including taxes (e.g. GST). You may switch plans
            or cancel at any time, but charges already processed are
            non-refundable except as described in our Refund Policy below. */}
            Simplifyte offers free and paid subscription plans. New users
            receive a {loading ? "..." : days || 14}-day free trial at signup.
            During the trial, the Service is free; if not canceled before trial
            end, your chosen paid plan will commence and you will be charged the
            applicable fee. You may cancel anytime before the trial expires, so
            as to avoid charges. After the trial, subscriptions renew
            automatically on the due date (e.g. monthly or annually, as per your
            choice). You authorize us (via Razorpay or other payment gateway) to
            charge your chosen payment method (credit/debit card, UPI, etc.) for
            the subscription fees, including taxes (e.g. GST). You may switch
            plans or cancel at any time, but charges already processed are
            non-refundable except as mentioned in our Refund Policy.
          </li>
          <li>
            <strong>Free Trial:</strong> {""}
            {/* The 7-day trial is available once per
            new account. No refunds will be provided for unused portions of a
            trial. The trial offers you a chance to evaluate the Service; after
            it ends, billing begins automatically unless you cancel in your
            account settings or by contacting support. */}
            The {loading ? "..." : days || 14} trial is available once per new
            account. No refunds will be provided for unused portions of a trial.
            The trial offers you a chance to evaluate the Service; after it
            ends, billing begins automatically unless you either cancel in your
            account settings or by contacting support.
          </li>
          <li>
            <strong>Fees and Payment:</strong> {""}
            {/* You agree to pay all fees as
            specified at signup. Fees may change, but we will notify you in
            advance. If a payment fails (e.g. insufficient funds, expired card),
            we may retry or suspend your Service until payment is resolved. We
            are not responsible for payment gateway errors. Customers outside
            India agree to handle any currency conversion or local taxes. We
            follow applicable tax laws; India-based customers pay GST where
            required. */}
            You agree to pay all fees as specified at signup. Fees may change,
            which would be notified, in advance. If a payment fails, we may
            retry or suspend your Service until the payment is resolved. We are
            not responsible for payment gateway errors. Customers outside India
            agree to handle any currency conversion or local taxes. We follow
            applicable tax laws; India-based customers pay GST where required.
          </li>
          <li>
            <strong>License Restrictions:</strong> {""}
            {/* You shall not (and shall not
            permit others to): (a) copy, modify, or create derivative works of
            the Service; (b) circumvent access controls; (c) use the Service for
            any illegal or unauthorized purpose (see Acceptable Use Policy
            below); (d) transfer or share your account with third parties; (e)
            harm or interfere with our systems or other users’ use of the
            Service. Violation may result in suspension or termination of your
            account without refund. */}
            You shall not (and shall not permit others to): (a) copy, modify, or
            create derivative works of the Service; (b) circumvent access
            controls; (c) use the Service for any illegal or unauthorized
            purpose (see Acceptable Use Policy below); (d) transfer or share
            your account with third parties; (e) harm or interfere with our
            systems or other users’ use of the Service. Violation may result in
            suspension or termination of your account without refund/notice.
          </li>
          <li>
            <strong>Ownership:</strong> We retain all rights, title and interest
            in the Service (and all associated intellectual property). You
            retain ownership of your uploaded data and content. We do not
            acquire any rights in your data (except the license to provide the
            Service). You represent that you have the rights to any data you
            submit and that it does not violate any third-party rights.
          </li>
          <li>
            <strong>Support and Service Level:</strong> {""}
            {/* We use reputable
            third-party hosting providers (with data centers in India) and
            strive to keep the Service available 24/7. However, we do not
            guarantee uninterrupted access. We may perform maintenance or
            updates; we will attempt to give advance notice if major downtime is
            planned. We offer technical support as described on our website. */}
            We use reputable third-party hosting providers (with data centers in
            India) and strive to keep the Service available 24/7. However, we do
            not guarantee uninterrupted access. We may perform maintenance or
            updates; will attempt to give advance notice if major downtime is
            planned. We offer technical support to, as described on our website.
          </li>
          <li>
            <strong>Service Changes:</strong> {""}
            {/* We may modify or discontinue
            features of the Service. If we do so, we will notify you and provide
            a reasonable transition. You agree that we are not liable for losses
            due to such changes. */}
            We may modify or discontinue features of the Service. If we do so,
            we will notify you at the earliest. You agree that we are not liable
            for any losses due to such changes.
          </li>
          <li>
            <strong>Termination:</strong> Either party may terminate your
            account at any time. We may suspend or terminate your access (with
            or without notice) if you materially breach these Terms or infringe
            any law or right of others (for example, through prohibited use).
            Upon termination, your data will be retained or deleted as per our
            Privacy Policy and Data Protection Addendum. We are not liable for
            any damages resulting from suspension or termination for cause.
          </li>
          <li>
            <strong>Free Trial and Refund:</strong> {""}
            {/* If you cancel your paid
            subscription within 7 days of signup, you will receive a full refund
            of the first payment. After 7 days, payments are non-refundable
            (except for service defects as described in the Refund Policy). If
            you believe you were charged in error, please contact support
            immediately. Razorpay’s policy provides that normal refunds (for
            overcharges) are completed within 5–7 business days . */}
            If you cancel your paid subscription within a week/month of signup,
            you will receive a full refund of the first payment. After a
            week/month, payments are non-refundable (except for service defects
            as described in the Refund Policy). If you believe you were charged
            in error, please contact support immediately. Razorpay’s policy
            provides that normal refunds (for overcharges) are completed within
            a week.
          </li>
          <li>
            <strong>Warranties Disclaimer:</strong> {""}
            {/* The Service is provided “AS
            IS.” To the maximum extent permitted by law, we disclaim all
            warranties, express or implied (including merchantability, fitness
            for a particular purpose, non-infringement). We do not guarantee
            that the Service will be error-free or uninterrupted. You use the
            Service at your own risk. */}
            The Service is provided “AS IT IS.” To the maximum extent permitted
            by law, we disclaim all warranties, express or implied (including
            merchantability, fitness for a particular purpose,
            non-infringement). We do not guarantee our Service to be error-free
            or uninterrupted. You use the Service at your own risk.
          </li>
          <li>
            <strong>Limitation of Liability:</strong> {""}
            {/* To the maximum extent
            allowed by law, Simplifyte’s aggregate liability under these Terms
            shall not exceed the total fees you have paid in the 12 months
            preceding the claim. We are not liable for any indirect, incidental,
            consequential, or punitive damages (including lost prof ts, data
            loss, or business interruption) arising from your use of the
            Service. These limitations apply regardless of the cause (contract,
            tort, negligence, etc.). Notwithstanding anything else, we are
            liable for our gross negligence or willful misconduct, but any such
            liability is capped as above. */}
            To the maximum extent allowed by law, Simplifyte’s aggregate
            liability under these Terms shall not exceed the total fees you have
            paid in the 12 months preceding the claim. We are not liable for any
            indirect, incidental, consequential, or punitive damages (including
            lost profits, data loss, or business interruption) arising from your
            use of the Service. These limitations apply regardless of the cause
            (contract, tort, negligence, etc.). Notwithstanding anything else,
            we are liable for our gross negligence or willful misconduct, but
            any such liability is capped as above.
          </li>
          <li>
            <strong>Indemnification:</strong> You agree to indemnify and hold
            Simplifyte and its officers harmless from any claims or losses
            arising from your misuse of the Service, violation of these Terms,
            or infringement of any rights. We will notify you promptly of any
            third-party claims and give you the opportunity to defend at your
            expense.
          </li>
          <li>
            <strong>Dispute Resolution:</strong> {""}
            {/* These Terms are governed by
            Indian law. Any dispute shall first be attempted to be resolved
            amicably through mutual discussion. Failing that, disputes shall be
            subject to exclusive jurisdiction of the courts of Bhavnagar,
            Gujarat, India . This clause survives termination of these Terms. */}
            These Terms are governed by Indian law. Any dispute shall first be
            attempted to be resolved amicably through mutual discussion.
            Failing, disputes shall be subjected to exclusive jurisdiction of
            the courts of Bhavnagar, Gujarat, India.
          </li>
          <li>
            <strong>Force Majeure:</strong> {""}
            {/* We are not liable for failure to
            perform due to causes beyond our control (force majeure), including
            natural disasters, pandemics, acts of government, war, or major
            Internet failures. If critical dependencies (like payment gateways
            or hosting) fail, we will work to restore service promptly and
            notify you. If service is severely disrupted, you may request a
            pro-rata refund for the unused period (as a sole remedy), except for
            force majeure events. */}
            We are not liable for failure to perform which are beyond our
            control (force majeure), including natural disasters, pandemics,
            acts of government, war, or major Internet failures. If critical
            dependencies (like payment gateways or hosting) fail, we will work
            to restore service promptly and notify you. If service is severely
            disrupted, you may request a pro-rata refund for the unused period
            (as a sole remedy), except for force majeure events.
          </li>
          <li>
            <strong>Entire Agreement:</strong> {""}
            {/* These Terms (including all
            policies referenced herein) constitute the entire agreement between
            you and Simplifyte regarding the Service. If any term is found void
            or unenforceable, the remainder will remain in ef ect. No waiver of
            any term shall be deemed a further or continuing waiver. */}
            These Terms (including all policies referred herein) constitute the
            entire agreement between you and Simplifyte, regarding the Service.
            If any term is found void or unenforceable, the remainder will
            remain in effect. No waiver of any term shall be deemed a further or
            continuing waiver.
          </li>
        </ul>
        <p className="mb-4" style={{ textAlign: "justify" }}>
          Please read all policies carefully. By using our Service, you
          acknowledge that you have read and agree to all terms herein.
        </p>
      </div>
      <CustomFooter />
    </>
  );
};

export default TermsAndConditions;
